/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var People1MinusIcon16Solid = forwardRef('People1MinusIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11.5 4.5a3.5 3.5 0 1 1-7 0 3.5 3.5 0 0 1 7 0Z" }),
        React.createElement("path", { d: "M8 10c0-.552-.448-1.007-.999-.967-1.82.134-4.264.768-4.864 3.574C1.975 13.363 2.627 14 3.4 14H7a1 1 0 0 0 1-1v-3Z" }),
        React.createElement("path", { d: "M9.7 11a.7.7 0 0 0-.7.7v.6a.7.7 0 0 0 .7.7h4.6a.7.7 0 0 0 .7-.7v-.6a.7.7 0 0 0-.7-.7H9.7Z" })));
});
